import React from 'react';
import CSVImportUnits from '../../components/CSVImportUnits';

/**
 * Wraps CSVImportUnits for ProjectMasterView. Passes areaUnit from selected config
 * and forwards onImport with API payloads (list from buildUnitApiPayload).
 */
export default function ImportCSVModal({
  open,
  onClose,
  onImport,
  projectName,
  configurationId,
  configurationName,
  areaUnit = 'sqft',
}) {
  return (
    <CSVImportUnits
      open={open}
      onClose={onClose}
      onImport={onImport}
      configurationName={configurationName || (configurationId ? `Configuration ${configurationId}` : '')}
      areaUnit={areaUnit}
    />
  );
}
